import React from 'react';
import TableCell from '@material-ui/core/TableCell';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import DataTableColumnWithIcons from './DataTableColumnWithIcons';

const DataTableHeaderTableCell = styled.div`
  display: inline-flex;
  align-items: center;
  .sortable {
    cursor: pointer;
    font-size: 1em;
  }
  .icon {
    color: #757575;
    font-size: 1em;
  }
  .icon.reversed {
    transform: rotate(180deg);
  }
  .icon.inactive {
    visibility: hidden;
  }
  &:hover .icon {
    cursor: pointer;
  }
  &:hover .icon.inactive {
    visibility: initial;
    color: #757575;
  }
}
`;

const DataTableHeaderCell = (props) => {
  const { label, align = 'left' } = props;

  return (
    <TableCell align={align} variant={'head'} >
      <DataTableHeaderTableCell>
        <DataTableColumnWithIcons {...props}>{label}</DataTableColumnWithIcons>
      </DataTableHeaderTableCell>
    </TableCell>
  );
};

DataTableHeaderCell.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  align: PropTypes.oneOf(['left', 'right']),
};

export default DataTableHeaderCell;
